import "core-js/modules/es.array.filter";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/yujian_admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Editor from "@/components/Editor";
export default {
  components: {
    Editor: Editor
  },
  data: function data() {
    return {
      form: {
        language: "",
        title: "",
        content: "",
        cover: "",
        id: "",
        type_id: "",
        top: '',
        state: '',
        author: '',
        game_type: 'sys',
        is_banner: '',
        banner_title: ''
      },
      picfileList: [],
      dialogShow: false,
      rules: {
        title: [{
          required: true,
          message: "请输入标题",
          trigger: "blur"
        }],
        type_id: [{
          required: true,
          message: "请选择类型",
          trigger: "blur"
        }],
        top: [{
          required: true,
          message: "请选择",
          trigger: "blur"
        }],
        is_banner: [{
          required: true,
          message: "请选择",
          trigger: "blur"
        }],
        content: [{
          required: true,
          message: "请输入内容",
          trigger: "blur"
        }],
        state: [{
          required: true,
          message: "请选择状态",
          trigger: "blur"
        }],
        author: [{
          required: true,
          message: "请输入作者",
          trigger: "blur"
        }],
        // game_type: [{ required: true, message: "请选择公告类型", trigger: "blur" }],
        banner_title: [{
          required: true,
          message: "请输入轮播图标题",
          trigger: "blur"
        }],
        cover: [{
          required: true,
          message: "请上传轮播图",
          trigger: "blur"
        }]
      },
      announceTypeList: []
    };
  },
  methods: {
    init: function init(data) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.dialogShow = true;

                _this.$api.announceTypeList().then(function (res) {
                  if (res.code == 0) {
                    _this.announceTypeList = res.data;
                  }
                });

                if (data) {
                  _this.form = {
                    id: data.id,
                    type_id: data.type_id,
                    title: data.title,
                    cover: data.cover,
                    top: data.top,
                    content: data.content,
                    author: data.author,
                    state: data.state,
                    language: data.language,
                    game_type: data.game_type,
                    banner_title: data.banner_title,
                    is_banner: data.is_banner
                  };
                  _this.form.content = _this.$utils.textRepl(data.content);
                  _this.picfileList = data.cover ? [data.cover] : [];
                }

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    announceTypeChange: function announceTypeChange(e) {
      var data = this.announceTypeList.filter(function (item) {
        return item.id == e;
      });
      this.form.language = data[0].language;
    },
    imgChange: function imgChange(e) {
      this.picfileList = e;
      this.form.cover = e[0] && e[0].response ? e[0].response.data : '';
    },
    onEditorChange: function onEditorChange(e) {
      this.form.content = e;
    },
    hide: function hide() {
      this.dialogShow = false;
    },
    clearData: function clearData() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      this.form = {
        id: type ? this.form.id : "",
        type_id: "",
        title: "",
        cover: "",
        content: "",
        state: '',
        top: '',
        language: '',
        author: '',
        status: '',
        game_type: 'sys'
      };
      this.picfileList = [];
      this.$refs.ruleForm.resetFields();
    },
    submitData: function submitData() {
      var _this2 = this;

      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          var data = JSON.parse(JSON.stringify(_this2.form));
          data.content = data.content.replaceAll(_this2.$imgUrl, '');

          if (data.content == '<p><br></p>') {
            data.content = '';
          }

          var reqFn = data.id ? 'updAnnounce' : 'addAnnounce';

          _this2.$api[reqFn](data).then(function (res) {
            if (res.code == 0) {
              _this2.$message({
                message: '操作成功',
                type: 'success'
              });

              _this2.hide();

              _this2.$emit('change');
            }
          });
        }
      });
    }
  }
};